import { Component, Inject, InjectionToken, OnInit } from '@angular/core';

import { SHARED_MODULES } from '../../../../shared.';
import { GetLinkPipe } from '../../../pipes/get-link.pipe';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

type MasterRuleNameDtypeElement = {
	value: string;
	id: number;
	type: 'RULE' | 'FOLDER';
	is_active: boolean;
	children_count: number;
};

@Component({
	selector: 'app-master-rule-name-dtype',
	templateUrl: './master-rule-name-dtype.component.html',
	styleUrls: ['./master-rule-name-dtype.component.scss'],
	imports: [SHARED_MODULES, GetLinkPipe, PhIconComponent],
	standalone: true
})
export class MasterRuleNameDtypeComponent implements OnInit {
	protected element: MasterRuleNameDtypeElement;

	constructor(@Inject(ELEMENT) private readonly elementInjected: IInjectedElementDtype<MasterRuleNameDtypeElement>) {}

	protected get isFolder(): boolean {
		return this.element?.type === 'FOLDER';
	}

	protected get editRoute(): Array<string | number> {
		return ['stand', 'master-rule', 'edit', this.element.id];
	}

	ngOnInit(): void {
		this.element = this.elementInjected.element;
	}
}
